import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SmartFixBannerComponent } from './smart-fix-banner.component';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [SmartFixBannerComponent],
  imports: [CommonModule, DgxComponentsButtonModule],
  providers: [],
  exports: [SmartFixBannerComponent],
})
export class SmartFixBannerModule {}
